import { jsonHeaders } from "@services/api/http";

interface FavoriteResponse {
  success: boolean;
  isFavorited: boolean;
  favoriteCount: number;
}

/**
 * Toggle favorite status for an element
 * @param elementId The element ID to toggle favorite for
 * @returns Promise with the new favorite state and count
 */
export async function toggleElementFavorite(
  elementId: string,
): Promise<FavoriteResponse> {
  const response = await fetch("/element/favorite", {
    method: "POST",
    headers: jsonHeaders(),
    body: JSON.stringify({ element_id: elementId }),
  });

  if (!response.ok) {
    throw new Error(`Favorite toggle failed: ${response.status}`);
  }

  return response.json();
}

/**
 * Increment download count for elements (fire and forget)
 * @param elementIds Array of element IDs to increment
 */
export async function incrementDownloadCounts(
  elementIds: string[],
): Promise<void> {
  // Filter out "transparent" string identifier
  const validIds = elementIds.filter((id) => id !== "transparent");

  if (validIds.length === 0) return;

  try {
    await fetch("/element/download-count", {
      method: "POST",
      headers: jsonHeaders(),
      body: JSON.stringify({ element_ids: validIds }),
    });
  } catch (error) {
    // Log but don't throw - download counting is non-critical
    console.error("Download count increment failed:", error);
  }
}
